var choices = require('./choices');

var caseStudySlide = function(question,frame,modal) {
    // clear it out
    console.log(question);
    // set history
    $(frame).find('.history').html(question.acf.patient_history);
    // set question
    $(frame).find('.question').html(question.post_title);
    // set choices
    $(frame).find('.choices-row .choices .list-group').html('');
    $(frame).find('.choices-row .choices .list-group').append(choices(question.acf,question.user_choice));
    $('input[name=answer]').change(function() {
        console.log('changed');
        question.user_choice = $(this).val();
    });


    var imageList = $(frame).find('.image-list');
    // remove image-list
    $(imageList).html('');

    if ( typeof question.acf.images !== 'undefined' && question.acf.images.length) {
        _(question.acf.images).each(function(image) {
            var image_string = '<li><span class="glyphicon glyphicon-search magnify"></span>' +
                '<img src="'+ image.url +'" /></li>';
            var imageLi = $.parseHTML(image_string);
            $(imageLi).find('img').click(function() {
                var modalDiv = $('#'+ global.modal);
                $(modalDiv).on('hidden.bs.modal', function (e) {
                    $(modalDiv).find('.modal-content').html('');
                });
                var modalcontentstr = '<div class="modal-body magnify-image"><img src="'+ image.url  +'" /></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div>';
                var modalContent = $.parseHTML(modalcontentstr);
                $(modalDiv).find('.modal-content').append(modalContent);
                $(modalDiv).modal();
            });
            $(imageList).append(imageLi);
        });
    }
    // set images
}


module.exports = caseStudySlide;



//////////////////
// WEBPACK FOOTER
// ./src/casestudy_slide.js
// module id = 295
// module chunks = 0